import {
  AdminPatchRequest,
  AdminRolesPaginated,
  AdminsGetRequest,
  AdminseGetResponsePaginated,
  CreateAdminRequest,
  CreateAdminResponse,
  TAdminInfoResponse,
  TSettingsParams,
  TSettingsParamsPaginated,
} from 'shared/types/admins.types';
import { IdResponse, MessageResponse } from 'shared/types/types';
import { TOrganizationRequest, TOrganizationResponse } from './moderator';
import { edpApiV1 } from './index';

export const employeesApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    getAdmins: build.query<AdminseGetResponsePaginated, AdminsGetRequest>({
      query: params => ({ url: '/v1/admin/hr/admin-management/admins', method: 'GET', params }),
      providesTags: ['admins'],
    }),
    getAdminsInfo: build.query<TAdminInfoResponse, IdResponse>({
      query: params => ({ url: '/v1/admin/hr/admin-management/admins/info', method: 'GET', params }),
      providesTags: ['admins-info'],
    }),
    createAdmin: build.mutation<CreateAdminResponse, CreateAdminRequest>({
      query: body => ({ url: '/v1/admin/hr/admin-management/admins', method: 'POST', body }),
      invalidatesTags: ['admins'],
    }),
    deleteAdmin: build.mutation<IdResponse, { employeeId: number; active: boolean }>({
      query: body => ({ url: '/v1/admin/hr/admin-management/admins', method: 'PATCH', body }),
      invalidatesTags: ['admins'],
    }),
    updateAdmin: build.mutation<MessageResponse, AdminPatchRequest>({
      query: body => ({ url: '/v1/admin/hr/admin-management/admins', method: 'PATCH', body }),
      invalidatesTags: ['admins', 'admins-info', 'viewer/organizations'],
    }),
    getAdminOrganizations: build.query<TOrganizationResponse[], TOrganizationRequest>({
      query: params => ({ url: '/v1/admin/hr/admin-management/organizations', method: 'GET', params }),
      providesTags: ['admins-organization'],
    }),
    getAdminRoles: build.query<AdminRolesPaginated, { page: number; size: number }>({
      query: params => ({ url: '/v1/admin/hr/admin-management/role', method: 'GET', params }),
      providesTags: ['roles'],
    }),
    getSettings: build.query<TSettingsParamsPaginated, void>({
      query: () => ({ url: '/v1/admin/settings/parameters', method: 'GET' }),
      providesTags: ['settings'],
    }),
    updateSettings: build.mutation<TSettingsParams, { id: number; value: string }>({
      query: body => ({ url: '/v1/admin/settings/parameters', method: 'PATCH', body }),
      invalidatesTags: ['settings'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAdminOrganizationsQuery,
  useLazyGetAdminOrganizationsQuery,
  useGetAdminRolesQuery,
  useLazyGetAdminRolesQuery,
  useCreateAdminMutation,
  useUpdateAdminMutation,
  useDeleteAdminMutation,
  useGetAdminsQuery,
  useLazyGetAdminsQuery,
  useGetSettingsQuery,
  useLazyGetSettingsQuery,
  useUpdateSettingsMutation,
  useGetAdminsInfoQuery,
  useLazyGetAdminsInfoQuery,
} = employeesApi;
